import {signOutUser} from './authHelpers'

export default {
  logout: signOutUser,
}
